import { LatLngTuple } from 'leaflet';
import { useMap } from 'react-leaflet';

interface Props {
  center: LatLngTuple;
  zoom: number;
}

export function ResetDefaultButton(props: Readonly<Props>) {
  const map = useMap();

  const handleClick = () => {
    map.flyTo(props.center, props.zoom);
  };
  return (
    <button
      className={'text-center'}
      onClick={handleClick}
      style={{
        position: 'absolute',
        top: '80px',
        left: '10px',
        zIndex: 1000,
        background: 'white',
        border: '2px solid rgba(0,0,0,0.2)',
        cursor: 'pointer',
        borderRadius: '4px',
        width: '34px',
        height: '34px',
      }}>
      <img src={'/theme/media/reset.svg'} width="15" alt="Reset zoom and center" />
    </button>
  );
}
